import styled from "@emotion/styled";
import React from "react";
import { GelScreenDetectorContext } from "@tal-gel/components";

const ModuleContainer = ({
  id,
  children,
  height,
  marginTop,
  marginBottom,
  paddingTop,
  paddingBottom,
}) => {
  const { isLargerThanSmScreen, screen } = React.useContext(GelScreenDetectorContext);

  const SModuleContainer = styled.section(
    {
      marginTop: isLargerThanSmScreen(screen) ? 96 : 40,
      marginBottom: isLargerThanSmScreen(screen) ? 96 : 40,

      "&:first-of-type": {
        marginTop: 0,
      },

      "&:last-of-type": {
        marginTop: 0,
        marginBottom: 0,
      },
    },

    (props) => ({
      height: props.height,
      marginTop: props.marginTop,
      marginBottom: props.marginBottom,
      paddingTop: props.paddingTop,
      paddingBottom: props.paddingBottom,
    })
  );

  return (
    <SModuleContainer
      id={id}
      height={height}
      marginTop={marginTop}
      marginBottom={marginBottom}
      paddingTop={paddingTop}
      paddingBottom={paddingBottom}
    >
      {children}
    </SModuleContainer>
  );
};
export default ModuleContainer;
